$(document).ready(function() {
  var button = $('#button-confirm-payment')

  $('#input-amount').on('keyup keypress change', function(e) {
    enableDisabledButton()
  })

  $('.payment-amount-item').click(function() {
    enableDisabledButton()
  })

  $('.max-payment-amount').click(function() {
    var balance = $(this).data('balance')

    inputAmount.value = balance
    inputAmount.dispatchEvent(new Event("change"))
  })

  function enableDisabledButton() {
    setTimeout(function(){
      isInputAmount = $('#input-amount').val().length >= 1

      if (isInputAmount) {
        button.removeAttr('disabled')
      } else {
        button.attr('disabled', true)
      }
    }, 200);
  }
})